import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { firebaseConfig } from "./firebaseConfig";

// Initialize Firebase
let app;
try {
  app = initializeApp(firebaseConfig);
  console.log("✅ Firebase app initialized successfully");
  console.log("Project ID:", firebaseConfig.projectId);
} catch (error) {
  console.error("❌ Firebase initialization error:", error);
  throw error;
}

// Initialize Firebase services
let auth, db, storage;

try {
  auth = getAuth(app);
  db = getFirestore(app);
  storage = getStorage(app);
  console.log("✅ Firebase services initialized successfully");
  console.log("Auth domain:", firebaseConfig.authDomain);
} catch (error) {
  console.error("❌ Firebase service initialization error:", error);
  throw error;
}

export { auth, db, storage };
export default app;

